module.exports = __webpack_public_path__ + "img/UTJORD-4.fc7cde2d.jpg";